import React from "react";
import {
  RegisterOptions,
  useFormContext,
  useFormState,
  useWatch,
} from "react-hook-form";

import { Input, InputProps } from "../Input";

type Register = Omit<RegisterOptions, "onChange" | "onBlur">;

export type FormInputProps = InputProps & {
  name: string;
  register?: Register;
};

export const FormInput = (props: FormInputProps) => {
  const { register } = useFormContext();
  const value = useWatch({ name: props.name, defaultValue: "" });
  const { errors } = useFormState();

  const { pattern, valueAsNumber, valueAsDate, ...restRegisterProp } =
    props.register || {};

  const registerOptions: RegisterOptions = {
    onChange: props.onChange,
    onBlur: props.onBlur,
    disabled: props.disabled,
    required: props.required,
    ...restRegisterProp,
  };

  if (!pattern && !valueAsDate && props.type === "number") {
    registerOptions.valueAsNumber = true;
  }

  if (process.env.NODE_ENV === "development") {
    if (pattern && props.type === "number") {
      console.warn(
        "FormInput: pattern and type `number` are incompatible. valueAsNumber will be ignored."
      );
    }

    if (valueAsDate && props.type === "number") {
      console.warn(
        "FormInput: valueAsDate and type `number` are incompatible."
      );
    }
  }

  const utils = register(props.name, registerOptions);

  return (
    <Input
      error={Boolean(errors[props.name])}
      {...utils}
      {...props}
      value={value}
      ref={utils.ref}
      onChange={utils.onChange}
      onBlur={utils.onBlur}
    />
  );
};

FormInput.displayName = "FormInput";

export default FormInput;
